// extracted by mini-css-extract-plugin
export default {"recos":"w4-z","productCardOverride":"x4-z","rowHasBadge":"y4-z"};